import React, { Component, Fragment } from "react"
import { isEmpty } from "lodash"
import styles from "./styles"
import { withStyles } from "@material-ui/styles"
import {
  Chip,
  Typography,
  Icon,
  Avatar,
  Hidden,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Grid,
  Box,
  Divider,
} from "@material-ui/core"
import CircleAvatar from "../../components/CircleAvatar/index"

class FilterBar extends Component {
  state = { isHovering: null }

  handleMouseHover(i) {
    this.setState({ isHovering: i })
  }

  handleMouseExit() {
    this.setState({ isHovering: null })
  }
  // componentDidMount() {
  //   this.props.setFilter(this.props.filters)
  // }
  // componentDidUpdate() {
  //   this.props.setFilter(this.props.filters)
  // }
  render() {
    const { props } = this

    const { filters, setState, creatorFilters, classes } = props
    const { isHovering } = this.state

    return (
      <Fragment>
        {/* WEB VIEW */}
        <Hidden smDown>
          <div
            style={{
              backgroundColor: "#f8f8f8",
              width: "100%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Typography style={{ marginLeft: "32px" }}>Filters:</Typography>
            {filters.concat(creatorFilters).map((filter, i) => {
              return filter.type === "creator" ? (
                <CreatorFilter
                  key={i}
                  index={i}
                  filter={filter}
                  filters={creatorFilters}
                  setState={e => setState(e)}
                  isHovering={isHovering}
                  handleMouseHover={() => this.handleMouseHover(i)}
                  handleMouseExit={() => this.handleMouseExit()}
                  classes={classes}
                  onChangeCreatorFilter={props.onChangeCreatorFilter}
                />
              ) : (
                <Filter
                  key={i}
                  filter={filter}
                  filters={filters}
                  setState={e => setState(e)}
                  classes={classes}
                  setFilter={this.props.setFilter}
                />
              )
            })}
          </div>
        </Hidden>
        {/* MOBILE VIEW */}
        <Hidden mdUp>
          <Divider />
          <div
            style={{
              backgroundColor: "#f8f8f8",
              width: "100%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <ExpansionPanel className={classes.collapseStyles}>
              <ExpansionPanelSummary
                className={classes.collapseSummary}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Box
                  component="div"
                  m={1}
                  className={classes.collapseSummaryRow}
                >
                  <Typography
                    variant="p"
                    className={classes.activeCollapseOption}
                  >
                    Filters
                  </Typography>
                </Box>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails className={classes.collapseDetails}>
                <Grid
                  container
                  spacing={2}
                  style={{ justifyContent: "center" }}
                >
                  {filters.concat(creatorFilters).map((filter, i) => {
                    return filter.type === "creator" ? (
                      <Grid item sm={6}>
                        <CreatorFilter
                          key={i}
                          index={i}
                          filter={filter}
                          filters={creatorFilters}
                          setState={e => setState(e)}
                          isHovering={isHovering}
                          handleMouseHover={() => this.handleMouseHover(i)}
                          handleMouseExit={() => this.handleMouseExit()}
                          classes={classes}
                          onChangeCreatorFilter={props.onChangeCreatorFilter}
                        />
                      </Grid>
                    ) : (
                      <Grid item sm={6}>
                        <Filter
                          key={i}
                          filter={filter}
                          filters={filters}
                          setState={e => setState(e)}
                          classes={classes}
                          setFilter={this.props.setFilter}
                        />
                      </Grid>
                    )
                  })}
                </Grid>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          </div>
        </Hidden>
      </Fragment>
    )
  }
}

class Filter extends React.Component {
  render() {
    const { props } = this
    const { filter, setState, filters } = props

    return (
      <div
        style={{
          diplay: "flex",
          alignItems: "center",
          margin: "8px",
        }}
      >
        <Chip
          avatar={
            <Avatar
              className={props.classes.closeAvatar}
              onClick={e => {
                const newFilters = filters.filter(x => x.name !== filter.name)
                if (newFilters.length > 0) {
                  localStorage.setItem(
                    "shootsFilters",
                    JSON.stringify({
                      and: JSON.parse(localStorage.shootsFilters).and,
                      filters: newFilters.map(x => x.id),
                    })
                  )
                } else {
                  localStorage.removeItem("shootsFilters")
                }
                setState({
                  filters: newFilters,
                })
                this.props.setFilter(newFilters)
              }}
            >
              <Icon className={props.classes.closeIcon}>close</Icon>
            </Avatar>
          }
          label={filter.name}
          color="primary"
          style={{ color: "white" }}
        />
      </div>
    )
  }
}

class CreatorFilter extends React.Component {
  render() {
    const { props } = this
    const { filter, setState, filters, isHovering, index } = props
    const onClick = e => {
      const newFilters = filters.filter(x => x.name !== filter.name)

      if (newFilters.length > 0) {
        localStorage.setItem("shootsCreatorFilters", JSON.stringify(newFilters))
      } else {
        localStorage.removeItem("shootsCreatorFilters")
      }
      setState({ creatorFilters: newFilters })

      this.props.onChangeCreatorFilter(newFilters)
    }
    return (
      <div
        style={{
          diplay: "flex",
          alignItems: "center",
          margin: "8px",
        }}
      >
        <Chip
          avatar={
            isHovering === index ? (
              <Avatar
                className={props.classes.closeAvatar}
                onMouseEnter={props.handleMouseHover}
                onMouseLeave={props.handleMouseExit}
                onClick={onClick}
              >
                <Icon className={props.classes.closeIcon}>close</Icon>
              </Avatar>
            ) : isEmpty(filter.profile_image) ? (
              <Avatar
                className={props.classes.closeAvatar}
                onMouseEnter={props.handleMouseHover}
                onMouseLeave={props.handleMouseExit}
                onClick={onClick}
              >
                <Icon className={props.classes.closeIcon}>person</Icon>
              </Avatar>
            ) : (
              <CircleAvatar
                image={filter.profile_image}
                type="chip"
                onMouseEnter={props.handleMouseHover}
                onMouseLeave={props.handleMouseExit}
                onClick={onClick}
              />
            )
          }
          label={filter.name}
          color="primary"
          style={{ color: "white" }}
        />
      </div>
    )
  }
}

export default withStyles(styles)(FilterBar)
